const state = {
    brand: {},
    brands: [],
}
const actions = {
    showBrands: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/brands`).then(response => {
                context.commit('SHOW_BRANDS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showBrand: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/brands/${id}`).then(response => {
                context.commit('SHOW_BRAND', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeBrand: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/brands`, payload).then(response => {
                context.commit('STORE_BRAND', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateBrand: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/brands/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyBrand: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/brands/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_BRAND: (state, payload) => {
        state.brand = payload
    },
    SHOW_BRANDS: (state, payload) => {
        state.brands = payload
    },
    STORE_BRAND: (state, payload) => {
        state.brand = payload
    }
}
const getters = {
    brand: state => {
        return state.brand
    },
    brands: state => {
        return state.brands
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}